import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Icon from '../AppIcon';

const FloatingActionButton = () => {
  const googlePlayUrl = 'https://play.google.com/store/apps/details?id=com.hirebroker.app&hl=en';
  const appStoreUrl = 'https://apps.apple.com/ug/app/hire-broker/id6476240355';
  const downloadPageUrl = 'https://hirebroker.co/download-app';

  const [isOpen, setIsOpen] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  const handleToggle = () => {
    if (isDismissed) {
      setIsDismissed(false);
      setIsOpen(true);
      return;
    }

    setIsOpen((prev) => !prev);
  };

  const handleDismiss = () => {
    setIsOpen(false);
    setIsDismissed(true);
  };

  return (
    <div className="fixed right-5 bottom-5 z-50 flex items-end justify-end">
      {!isDismissed && isOpen && (
        <div className="mb-3 w-80 rounded-3xl border border-slate-200 bg-white/95 p-4 shadow-2xl backdrop-blur-xl transition-all duration-300">
          <div className="flex items-start justify-between gap-3">
            <div className="flex items-center gap-3">
              <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-primary text-white shadow-md">
                <Icon name="MessageSquare" size={20} />
              </div>
              <div>
                <p className="text-sm font-semibold text-foreground">Need a broker fast?</p>
                <p className="mt-1 text-sm leading-6 text-muted-foreground">
                  Get personalized support for selling or renting property, and download our mobile app directly from Apple or Google Play.
                </p>
              </div>
            </div>
            <div className="flex items-center gap-1">
              <button
                type="button"
                onClick={() => {
                  setIsOpen(false);
                  setIsPinned(false);
                }}
                className="rounded-full p-2 text-slate-500 transition-colors duration-200 hover:bg-slate-100 hover:text-slate-900"
                aria-label="Close broker info"
              >
                <Icon name="X" size={16} />
              </button>
              <button
                type="button"
                onClick={handleDismiss}
                className="rounded-full p-2 text-slate-500 transition-colors duration-200 hover:bg-slate-100 hover:text-slate-900"
                aria-label="Dismiss broker CTA"
              >
                <Icon name="Trash" size={16} />
              </button>
            </div>
          </div>

          <div className="mt-4 grid gap-3">
            <a
              href={googlePlayUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center rounded-2xl border border-slate-200 bg-slate-950 px-4 py-3 text-sm font-semibold text-white transition-colors duration-200 hover:bg-slate-800"
            >
              <Icon name="Android" size={18} className="mr-2" />
              Google Play
            </a>
            <a
              href={appStoreUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center rounded-2xl border border-slate-200 bg-slate-950 px-4 py-3 text-sm font-semibold text-white transition-colors duration-200 hover:bg-slate-800"
            >
              <Icon name="Apple" size={18} className="mr-2" />
              App Store
            </a>
            
            <Link
              to="/contact"
              className="inline-flex items-center justify-center rounded-2xl border border-border bg-background px-4 py-3 text-sm font-semibold text-foreground transition-colors duration-200 hover:bg-secondary/10"
            >
              <Icon name="Phone" size={16} className="mr-2" />
              Contact broker
            </Link>
          </div>
        </div>
      )}

      <button
        type="button"
        onClick={handleToggle}
        className="flex h-14 w-14 items-center justify-center rounded-full bg-primary text-white shadow-2xl transition-transform duration-200 hover:-translate-y-1 focus:outline-none focus:ring-2 focus:ring-primary/40"
        aria-label={isOpen ? 'Hide broker CTA panel' : 'Show broker CTA panel'}
        aria-expanded={isOpen}
      >
        <Icon name={isOpen ? 'ChevronDown' : 'MessageSquare'} size={22} />
      </button>
    </div>
  );
};

export default FloatingActionButton;
